<!-- Pie Settings -->
@if (isPieWidget) {
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <span class="form-label" translate>Design</span>
          <div class="btn-group d-flex btn-group-toggle" name="pieTypeRadio"
            ngbRadioGroup>
            @for (pieType of pieChartTypes; track pieType) {
              <label [class.active]="isSelectedPieChartType(pieType)" class="btn btn-outline-primary w-25"
                ngbButtonLabel>
                <input (click)="onPieChartTypeSelected(pieType)" ngbButton
                  type="radio">
                <span [innerText]="getPieChartTypeLabel(pieType)"></span>
              </label>
            }
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <span class="form-label" translate>Aggregation strategy</span>
          <div class="btn-group d-flex btn-group-toggle" name="aggregationStrategyRadio"
            ngbRadioGroup>
            @for (strategy of aggregationStrategies; track strategy) {
              <label [class.active]="isSelectedAggregationStrategy(strategy)" class="btn btn-outline-primary w-50"
                ngbButtonLabel>
                <input (click)="onAggregationStrategySelected(strategy)" ngbButton
                  type="radio">
                <span [innerText]="getAggregationStrategyLabel(strategy)"></span>
              </label>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <scitis-widget-time-period-input
          (timePeriodChanged)="onTimePeriodChanged($event)"
          [disabled]="isTimePeriodDisabled"
          [timePeriod]="userDefinedWidget().userDefinedChartDetails.rangeValue">
        </scitis-widget-time-period-input>
      </div>
    </div>
    <scitis-widget-configuration-signals-selector
      (signalSelectionChanged)="onSignalSelected($event)"
      [items]="usableSignals()"
      [multiSelection]="true"
      [selectedSignalsIds]="selectedSignalIds()"
      [showColor]="false"
      [validate]="false">
    </scitis-widget-configuration-signals-selector>
    <span class="form-label" translate>Configure selected signals</span>
    @if (!userDefinedWidget().userDefinedChartDetails.signals || userDefinedWidget().userDefinedChartDetails.signals.length===0) {
      <div
        class="alert alert-info text-center">
        <span translate>Currently no signals have been added, please add one from above.</span>
      </div>
    }
    <ul [(dragulaModel)]="userDefinedWidget().userDefinedChartDetails.signals"
      [dragula]="dragAndDropItems"
      class="list-group mb-3">
      @for (signal of sortByLabel(userDefinedWidget().userDefinedChartDetails.signals); track signal.signalId + ':' + signal.signalName) {
        <li class="list-group-item">
          <scitis-line-widget-axis-signal-item
            (signalRemoveFromAxis)="onSignalRemove($event)"
            (signalColorChanged)="onSignalColorChanged($event, signal)"
            [signalOriginalColor]="getSignalOriginalColor(signal)"
            [signalHasBeenDeleted]="hasSignalBeenDeleted(signal)"
            [signal]="signal">
          </scitis-line-widget-axis-signal-item>
        </li>
      }
    </ul>
    @if (hasDeletedSignalsMap().get(userDefinedWidget().id+'') ?? false) {
      <div class="d-flex align-items-center justify-content-center mb-0 mt-2 alert alert-warning text-center">
        <em class="fa-solid fa-circle-exclamation mr-2"></em>
        <span translate>Signals that have been deleted in the asset configuration have to be removed from the axis.</span>
      </div>
    }
  </div>
}
